'use client';
import { createContext } from 'react';
import { MeUser } from '@banzai/data/auth';

export interface MeContextInterface {
  isAuthenticated: boolean;
  user?: MeUser | null;
  service_id: string;
}

export const meContext = createContext<MeContextInterface>({
  isAuthenticated: false,
  service_id: '',
});

export function MeProvider({
  value,
  children,
}: {
  value: MeContextInterface;
  children: React.ReactNode;
}) {
  return <meContext.Provider value={value}>{children}</meContext.Provider>;
}
